// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ladderNews_heading__2eSIh {\n  position: sticky;\n  top: 0;\n}\n\n.ladderNews_list__3T8zo {\n  height: 100%;\n  margin: 1rem;\n}\n.ladderNews_list__3T8zo li {\n  margin-bottom: 1rem;\n  background: transparent !important;\n  color: var(--white-75);\n}", ""]);
// Exports
exports.locals = {
	"heading": "ladderNews_heading__2eSIh",
	"list": "ladderNews_list__3T8zo"
};
module.exports = exports;
